import React from 'react';
import styled from 'styled-components';
import { VideoWallController } from '../../Widgets/VideoWallController';

const PageContainer = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #000000;
`;

const VideoWallControlPage = () => {
  return (
    <PageContainer>
      <VideoWallController />
    </PageContainer>
  );
};

export default VideoWallControlPage;
